<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <ag-grid-vue
            ref="agGridTable"
            class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table vs-con-loading__container"
            :columnDefs="stockColumns"
            :defaultColDef="defaultColDef"
            :rowData="stockList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            @grid-ready="onGridReadyMatchS"
            :suppressCopyRowsToClipboard="true"
            :localeText="localeText"
            :suppressRowClickSelection="true"
            :pagination="true"
          >
          </ag-grid-vue>
        </vs-card>
      </b-col>
      <b-col lg="4">
        <vs-card>
          <b-row class="mt-4">
            <b-col v-if="ROLE != 'Company'">
              <b-row class="mb-2">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('Customer') + ': '"
                    class="vs-input--label pr-0 mr-0"
                    label-for="h-first-name"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <v-select
                    color="danger"
                    v-model="customer"
                    :options="customer_choices"
                    size="small"
                    label="CompanyName"
                    v-on:input="
                      getCustomerMarketplaces();
                      getCustomerDepoList();
                    "
                    autocomplete
                    ref="selectElement"
                    :disabled="stockList.length > 0"
                  >
                  </v-select>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="'* ' + $t('Marketplace') + ': '"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                v-model="marketplace"
                label="Name"
                :options="marketplace_choices"
                size="small"
                autocomplete
                ref="selectElement"
                :disabled="stockList.length > 0"
              >
                <template slot="option" slot-scope="option">
                  <b-row>
                    <b-col cols="2">
                      <img
                        v-if="mpControl(option.Name)"
                        :src="
                          require('../../assets/images/logo/' +
                            option.Name.trim() +
                            '.png')
                        "
                        width="30"
                        v-b-tooltip.hover.bottom="option.Name"
                        @error="errorImage"
                      />
                    </b-col>
                    <b-col>
                      {{ option.Prefix }} -
                      {{ option.Name }}
                    </b-col>
                  </b-row>
                </template>
              </v-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="'* ' + $t('Storehouse') + ': '"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="storehouse"
                :options="storehouse_choices"
                size="small"
                label="name"
                autocomplete
                ref="selectElement"
                name="storehouse"
                v-validate="'required'"
                :disabled="stockList.length > 0"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
                errors.first("storehouse")
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="4"></b-col>
            <b-col cols="8">
              <b-button
                style="border-color: white; width: 100%"
                v-on:click="listStock()"
                class="vs-con-loading__container bg-primary"
                id="loading-stock-list"
              >
                <Icon
                  icon="ph:list-fill"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("ListStock") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="4"> </b-col>
            <b-col>
              <b-button
                :disabled="!customer"
                class="bg-primary"
                style="border-color: white; width: 100%"
                v-on:click="isSidebarActiveAddWithExcel = true"
              >
                <Icon icon="icon-park-outline:excel" width="20" height="20" />
                {{ $t("AddWithExcel") }}</b-button
              >
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="'* ' + $t('Factor') + ': '"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <v-select
                color="danger"
                v-model="selectedFactor"
                :options="factor_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="factor"
                v-validate="'required'"
                :taggable="true"
                :disabled="stockList.length <= 0"
              >
              </v-select>

              <span class="text-danger text-sm" v-show="errors.has('factor')">{{
                errors.first("factor")
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="4" align-self="center">
              <b-form-group
                :label="'* ' + $t('Stock') + ': '"
                class="vs-input--label pr-0 mr-0"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <vs-input
                size="small"
                v-model="stockno"
                type="text"
                class="w-full"
                name="stockno"
                v-validate="'required'"
                :disabled="stockList.length <= 0"
              />
              <span class="text-danger text-sm" v-show="errors.has('stockno')">{{
                errors.first("stockno")
              }}</span>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col lg="4"> </b-col>
            <b-col>
              <b-button
                style="border-color: white; width: inherit"
                v-on:click="generateBarcode()"
                size="sm"
                :disabled="stockList.length <= 0"
              >
                {{ $t("Generate") }}
              </b-button>
            </b-col>
            <!--
            <b-col>
              <b-button
                style="border-color: white; width: inherit"
                v-on:click="copyToClipboard()"
                class="vs-con-loading__container"
                id="loading-stock-save"
                size="sm"
              >
                {{ $t("Copy") }}
              </b-button>
            </b-col>-->
          </b-row>

          <b-row class="mb-2">
            <b-col lg="4"> </b-col>
            <b-col cols="8">
              <b-button
                style="border-color: white; width: 100%"
                v-on:click="saveStock()"
                class="vs-con-loading__container bg-success"
                id="loading-stock-save"
                :disabled="stockList.length <= 0"
              >
                <Icon
                  icon="material-symbols:save-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("SaveStock") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="4"></b-col>
            <b-col cols="8">
              <b-button
                style="border-color: white; width: 100%"
                v-on:click="matchStockList()"
                class="vs-con-loading__container bg-warning"
                id="loading-match-stock-list"
              >
                {{ $t("MatchStockList") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="4"></b-col>
            <b-col cols="8">
              <b-button
                style="border-color: white; width: 100%"
                v-on:click="clear()"
                class="vs-con-loading__container bg-danger"
                id="loading-stock-save"
              >
                <Icon
                  icon="mdi:clear-bold"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Clear") }}
              </b-button>
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <vs-popup
      class="holamundo"
      :title="$t('AddWithExcel')"
      :active.sync="isSidebarActiveAddWithExcel"
      @close="closeExcelAddPopup"
      @cancel="closeExcelAddPopup"
      fullscreen
    >
      <vs-popup
        class="holamundo"
        :title="$t('MatchStockWithExcelUsage')"
        :active.sync="isSidebarActiveUsage"
        fullscreen
      >
        <UsageWizard
          :isSidebarActiveUsage="isSidebarActiveUsage"
          @closeUsageWizard="closeUsageWizard"
          :steps="steps"
          :title="'MatchStockWithExcelUsage'"
        />
      </vs-popup>
      <vs-prompt
        :title="$t('Submit')"
        :acceptText="$t('Save')"
        :cancelText="$t('Cancel')"
        @accept="addProductWithExcel"
        :active.sync="activePromptToProduct"
      >
        <div class="con-exemple-prompt">
          <b-row style="align-items: center">
            <b-col lg="12">
              <span
                >{{ $t("ConfirmToUpdateList") }} {{ $t("AreYSure") }}
                {{ $t("CantUndo") }}</span
              >
            </b-col>
          </b-row>
        </div>
      </vs-prompt>
      <!--
      <b-row class="mb-5">
        <b-col>
          <b-button
            class="bg-danger"
            style="border-color: white"
            v-on:click="showUsage()"
          >
            <Icon
              icon="wpf:ask-question"
              style="margin-right: 5px"
              width="20"
              height="20"
            />
          </b-button>
        </b-col>
      </b-row>-->
      <b-row>
        <b-col lg="6">
          <vs-card>
            <b-row class="mb-8 mt-8">
              <UploadBtnDynamic :isUploaded="isUploadedAddExcel" />
            </b-row>
            <b-row class="justify-content-md-end">
              <b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clearAddExcel()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="downloadSampleAddExcel()"
                >
                  {{ $t("SampleExcel") }}</b-button
                >
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="activePromptToProduct = true"
                >
                  {{ $t("Add") }}
                </b-button></b-col
              >
            </b-row>
          </vs-card>
          <span v-if="excelErrors.length > 0"> {{ excelErrors }}</span>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <vs-card>
                <ag-grid-vue
                  style="width: 100%; height: 400px"
                  class="ag-theme-alpine"
                  :suppressRowClickSelection="true"
                  :defaultColDef="defaultColDef"
                  :columnDefs="excelListColumnAdd"
                  :rowData="wholeAcceptedProductListAddExcel"
                  :localeText="localeText"
                  @grid-ready="onGridReadyStock"
                >
                </ag-grid-vue>
              </vs-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-popup>
    <vs-popup
      :title="$t('MatchStockList')"
      button-cancel="border"
      :active.sync="isSidebarActiveLocal"
      classContent="popup-example"
      fullscreen
    >
      <vs-prompt
        :title="$t('Submit')"
        :acceptText="$t('Delete')"
        :cancelText="$t('Cancel')"
        @accept="deleteMatched"
        :active.sync="activePromptToMatched"
        color="danger"
      >
        <div class="con-exemple-prompt">
          <b-row style="align-items: center">
            <b-col lg="12">
              <span
                >{{ $t("ConfirmToUpdateList") }} {{ $t("AreYSure") }}
                {{ $t("CantUndo") }}</span
              >
            </b-col>
          </b-row>
        </div>
      </vs-prompt>
      <vs-card>
        <b-row class="mb-2">
          <b-col v-if="ROLE != 'Company'">
            <b-form-group :label="$t('Company')" label-for="item-name">
              <v-select
                color="danger"
                v-model="customerFMatch"
                :options="customer_choices"
                size="small"
                autocomplete
                label="CompanyName"
                ref="selectElement"
                name="customer"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="$t('Marketplace')" label-for="item-name">
              <v-select
                color="danger"
                v-model="selectedMp"
                :options="mpOPTION"
                size="small"
                autocomplete
                ref="selectElement"
                name="customer"
                :taggable="true"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="$t('MarketplaceBarcode')" label-for="item-name">
              <v-select
                color="danger"
                v-model="selectedMpBarcode"
                :options="barcodematch_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="customer"
                :taggable="true"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="$t('MatchedBarcode')" label-for="item-name">
              <v-select
                color="danger"
                v-model="selectedMatchBarcode"
                :options="barcodematch_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="customer"
                :taggable="true"
              >
              </v-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group :label="$t('Multiplier')" label-for="item-name">
              <v-select
                color="danger"
                v-model="selectedMultiplier"
                :options="factor_options"
                size="small"
                autocomplete
                ref="selectElement"
                name="multiplier"
                :taggable="true"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-button
              style="border-color: white; width: 100%"
              v-on:click="addMatchingStock(0)"
              class="vs-con-loading__container bg-success"
              id="loading-stock-save"
            >
              <Icon
                icon="ph:git-merge"
                style="margin-right: 5px"
                width="20"
                height="20"
              />
            </b-button>
          </b-col>
        </b-row>
        <vs-divider></vs-divider>
        <b-row class="mb-2">
          <b-col lg="4" v-if="ROLE != 'Company'">
            <v-select
              color="danger"
              v-model="customerFRunReport"
              :options="customer_choices"
              size="small"
              label="CompanyName"
              autocomplete
              ref="selectElement"
            >
            </v-select>
          </b-col>
          <b-col cols="4">
            <b-button
              style="border-color: white; width: 100%"
              v-on:click="runMatchedQuery()"
              class="vs-con-loading__container bg-success"
              id="loading-stock-save"
            >
              <Icon
                icon="solar:play-bold"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("RunMatchedQuery") }}
            </b-button>
          </b-col>
        </b-row>
        <ag-grid-vue
          ref="agGridTable"
          class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
          :columnDefs="columnsProcess"
          :defaultColDef="defaultColDef"
          :rowData="processList"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          @grid-ready="onGridReadyProcess"
          :suppressCopyRowsToClipboard="true"
          :localeText="localeText"
          :suppressRowClickSelection="true"
          :editType="editType"
          @rowEditingStopped="onCellEditingStopped"
        >
        </ag-grid-vue> </vs-card
    ></vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import userJson from "../../../public/user.json";
import { uuid } from "vue-uuid";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import moment from "moment";
import UsageWizard from "../components/global-components/UsageWizard.vue";
export default {
  created() {
    this.editType = "fullRow";
    this.getMpNameOptions();
    this.customer_choices = this.company;
  },
  components: {
    UsageWizard,
    twoInfoButtonsDynamic,
    uuid,
    AgGridVue,
    vSelect,
    Icon,
    UploadBtnDynamic,
  },
  data() {
    return {
      barcodematch_options: [],
      selectedMp: "",
      selectedMultiplier: "",
      selectedMpBarcode: "",
      selectedMatchBarcode: "",
      customerFRunReport: "",
      customerFMatch: "",
      steps: [
        {
          imageSrc: "https://g4full.com/assets/usage/MatchStock-8.png",
          index: 0,
          markers: [
            {
              x1: 10,
              y1: 170,
              x2: -150,
              y2: 170,
              info:
                "1 - Excel ile Stok Eşleme işlemleri yapmak için öncelikle 'Stok Tanımları' menüsüne giriş yapınız",
            },
            {
              x1: 470,
              y1: 170,
              x2: 610,
              y2: 170,
              info:
                "2 - 'Toplu İşlemler' alanından Stok Eşleştir'e tıklayarak ilgili panelin açılmasını sağlayın",
            },
          ],
        },
        {
          imageSrc: "https://g4full.com/assets/usage/MatchStock-4.png",
          index: 0,
          markers: [
            { x1: 280, y1: 50, x2: 370, y2: 50, info: "3 - Müşteri seçimi yapın" },
            {
              x1: 390,
              y1: 210,
              x2: 490,
              y2: 210,
              info: "4 - Excel ile Ekle'ye tıklayın",
            },
          ],
        },
        {
          imageSrc: "https://g4full.com/assets/usage/MatchStock-6.png",
          index: 1,
          markers: [
            { x1: -300, y1: 170, x2: -170, y2: 170, info: "5 - Dosyayı yükleyin" },
            { x1: 210, y1: 400, x2: 210, y2: 340, info: "6 - Ekleye tıklayın" },
          ],
        },
        {
          imageSrc: "https://g4full.com/assets/usage/MatchStock-5.png",
          index: 2,
          markers: [
            {
              x1: 70,
              y1: 300,
              x2: 180,
              y2: 300,
              info:
                "7 - Dosya seçiniz kısmı onaylandıktan ve Liste görüntülendikten sonra işlemi onaylayabilirsiniz",
            },
          ],
        },
      ],
      isSidebarActiveUsage: false,
      excelErrors: [],
      editType: "",
      columnsProcess: [],
      processList: [],
      isSidebarActiveLocal: false,
      isUploaded: false,
      uploadMethod: "",
      activePromptToMatched: false,
      activePromptToProduct: false,
      isSidebarActiveAddWithExcel: false,
      isUploadedAddExcel: false,
      factor_options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      selectedMainBarcode: "",
      ROLE: this.$store.state.AppActiveUser.ROLE,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      storehouse: "",
      marketplace: "",
      customer: "",
      stockno: "",
      selectedFactor: "",
      marketplace_choices: [],
      storehouse_choices: [],
      customer_choices: [],
      mainstock_options: [],
      excelListColumnAdd: [],
      wholeAcceptedProductListAddExcel: [],
      stockList: [],
      stockColumns: [],
      mainBarcodes: [],
      copySuccess: false,
      matchingBarcodes: [],
      gridApiProcess: null,
      gridApiMatchS: null,
      gridColumnApiMatchS: null,
      gridColumnApi: null,
      gridColumnApiProcess: null,
      deleteMatchedData: [],
    };
  },
  methods: {
    getMpNameOptions() {
      this.mpNameListOption = [];
      this.mpOPTION = [];
      this.mpNameListOption = this.mpNameList;
      this.mpOPTION = Object.values(this.mpNameListOption);
    },
    runMatchedQuery() {
      const vs = this.$vs; 
      let compId = "";

      if (this.ROLE == "Company") compId = this.activeUserInfo.companyid;
      else compId = this.customerFRunReport.CompanyId;
      let obj = {
        companyId: compId,
        name: "SaveBarcodeForMatchBarcodes",
      };
      this.$store
        .dispatch("report/runReports", obj)
        .then((response) => {
          if (response.success == true) {
            vs.notify({
              text: response.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    closeUsageWizard(val = false) {
      this.isSidebarActiveUsage = val;
    },
    showUsage() {
      this.isSidebarActiveUsage = true;
    },
    deleteMatched() {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteStockMatching", this.deleteMatchedData.BarcodeMatchingId)
        .then((response) => { 
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.matchStockList();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    deleteMatchedBarcode() {
      this.activePromptToMatched = true;
    },
    onCellEditingStopped(event) {
      this.stockno = this.stockno.replace(/\?/g, "_");
      const vs = this.$vs;
      let obj = {};
      obj = {
        barcodeMatchingId: event.data.BarcodeMatchingId,
        marketPalaceBarcode: event.data.MarketPalaceBarcode,
        marketPlaceName: event.data.MarketPlaceName,
        matchingBarcode: event.data.MatchingBarcode,
        multiplier: event.data.Multiplier,
        companyId: event.data.CompanyId,
        companyName: event.data.CompanyName,
      };

      this.$store
        .dispatch("stock/updateStockMatching", obj)
        .then((response) => {
          if (response.status == 200) {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    editMatchedBarcode(param) {
      this.gridApiProcess.setFocusedCell(param.rowIndex, "MarketPlaceName");
      this.gridApiProcess.startEditingCell({
        rowIndex: param.rowIndex,
        colKey: "MarketPlaceName",
      });
    },

    matchStockList() {
      this.columnsProcess = [];
      var vs = this.$vs;
      let type = "material";

      vs.loading({
        container: `#loading-match-stock-list`,
        type,
        scale: 0.5,
      });
      this.$store.dispatch("stock/listStockMatchingAll").then((response) => {
        if (response.success == true) {
          setTimeout(() => {
            vs.loading.close("#loading-match-stock-list > .con-vs-loading");
          }, 1000);
          this.matchingBarcodes = JSON.parse(response.json);
          let columnList = Object.keys(this.matchingBarcodes[0]);
          this.processList = this.matchingBarcodes;
          this.isSidebarActiveLocal = true;

          this.columnsProcess.push({
            width: 100,
            pinned: "left",
            cellRendererFramework: "twoInfoButtonsDynamic",
            cellRendererParams: {
              detailMethodsOne: "editMatchedBarcode",
              tooltipOne: "editMatchedBarcode",
              iconDetailOne: "material-symbols:edit",
              iconColorOne: "#065a82",
              isParam: "true",
              detailMethodsTwo: "deleteMatchedBarcode",
              tooltipTwo: "deleteMatchedBarcode",
              iconDetailTwo: "ic:baseline-remove-circle",
              iconColorTwo: "#065a82",
            },
            editable: false,
          });
          columnList.forEach((val, index) => {
            if (val.toString() == "MarketPlaceName") {
              this.columnsProcess.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                editable: true,
                //   cellEditor: "agSelectCellEditor",
                //   cellEditorParams: { cellHeight: 20, values: this.mpOPTION },
                //  cellEditorParams: this.mpOPTION,
              });
            } else if (val.toString().includes("Date") == true)
              this.columnsProcess.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                valueFormatter: (params) => this.parseDate(params.data[val]),
                editable: true,
              });
            else if (
              val.toString().includes("Id") == false &&
              val.toString().includes("TrasnType") == false
            )
              this.columnsProcess.push({
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                editable: true,
              });
          });
        } else {
          setTimeout(() => {
            vs.loading.close("#loading-match-stock-list > .con-vs-loading");
          }, 1000);
        }
      });
    },
    setItem() {
      this.excelListColumnAdd = [];
      let columnList = Object.keys(this.wholeAcceptedProductListAddExcel[0]);
      columnList.forEach((value, index) => {
        this.excelListColumnAdd.push({
          headerName: this.$t(value),
          field: value,
          filter: "agSetColumnFilter",
        });
      });
    },
    addProductWithExcel() {
      const vs = this.$vs;

      if (this.transactionNo == "") {
        vs.notify({
          text: this.$t("InfoTransferNo"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else { 
        this.filterStockExcel(this.wholeAcceptedProductListAddExcel.length - 1);
      }
    },
    filterStockExcel(index) {
      const vs = this.$vs; 
      if (index < 0) {
        vs.notify({
          text: this.$t("Added"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        this.addMatchingStock(this.wholeAcceptedProductListAddExcel[index], index);
        index--;
        this.filterStockExcel(index);
      }
    },
    addMatchingStock(item, index) {
      //	console.log( this.$store.state.AppActiveUser)
      this.stockno = this.stockno.replace(/\?/g, "_");
      const vs = this.$vs;
      let obj = {};
      var createdId = uuid.v4();
      try {
        if (item == 0) {
          obj = {
            barcodeMatchingId: createdId,
            marketPalaceBarcode: this.selectedMpBarcode.toString(),
            marketPlaceName: this.selectedMp,
            matchingBarcode: this.selectedMatchBarcode.toString(),
            multiplier: parseFloat(this.selectedMultiplier),
            companyId:
              this.ROLE == "Company"
                ? this.$store.state.AppActiveUser.companyid
                : this.customerFMatch.CompanyId,
            companyName:
              this.ROLE == "Company"
                ? this.$store.state.AppActiveUser.userCode
                : this.customerFMatch.CompanyName,
          };
        } else {
          obj = {
            barcodeMatchingId: createdId,
            marketPalaceBarcode: item.marketPalaceBarcode.toString(),
            marketPlaceName: item.marketPlaceName,
            matchingBarcode: item.matchingBarcode.toString(),
            multiplier: parseFloat(item.multiplier),
            companyId:
              this.ROLE == "Company"
                ? this.$store.state.AppActiveUser.companyid
                : this.customer.CompanyId,
            companyName:
              this.ROLE == "Company"
                ? this.$store.state.AppActiveUser.userCode
                : this.customer.CompanyName,
          };
        }

        this.$store
          .dispatch("stock/addStockMatching", obj)
          .then((response) => {
            if (response.success == true) {
              if (item == 0) {
                vs.notify({
                  text: response.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.matchStockList();
              }
              //this.wholeAcceptedProductListAddExcel.splice(index, 1);
            } else {
              vs.notify({
                text: response.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            this.excelErrors.push({ error: error, item: item });
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } catch (error) {
        this.excelErrors.push({ error: error, item: item });
      }
    },
    clearAddExcel() {
      this.wholeAcceptedProductListAddExcel = [];
      this.isUploadedAddExcel = false;
    },
    downloadSampleAddExcel() {
      const link = document.createElement("a");
      link.href = userJson.assetsUrl + "StockMatchTemplate.xlsx";
      link.download = "SampleProductAcceptanceTemplate.xlsx";
      link.click();
    },
    closeExcelAddPopup() {
      this.isSidebarActiveAddWithExcel = false;
      this.isUploadedAddExcel = false;
      this.wholeAcceptedProductListAddExcel = [];
    },
    copyToClipboard() {
      const vs = this.$vs;
      navigator.clipboard
        .writeText(this.stockno)
        .then(() => {
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
          vs.notify({
            text: "Kopyalandı " + this.stockno,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
          });
        })
        .catch((err) => {
          console.error("Kopyalama hatası: ", err);
        });
    },
    generateBarcode() {
      let baseCode = this.generateRandomNumber(12);
      let checkDigit = this.calculateCheckDigit(baseCode);
      this.stockno = baseCode + checkDigit;
    },
    generateRandomNumber(length) {
      let result = "";
      result += Math.floor(Math.random() * 9) + 1;
      for (let i = 1; i < length; i++) {
        result += Math.floor(Math.random() * 10);
      }
      return result;
    },
    calculateCheckDigit(code) {
      let sum = 0;
      for (let i = 0; i < code.length; i++) {
        let num = parseInt(code[i]);
        sum += i % 2 === 0 ? num : num * 3;
      }
      let remainder = sum % 10;
      return remainder === 0 ? 0 : 10 - remainder;
    },
    clear() {
      this.customer = "";
      this.storehouse = "";
      this.marketplace = "";
      this.stockList = [];
      this.stockno = "";
      this.selectedFactor = "";
    },
    saveStock() {
      let type = "material";
      const vs = this.$vs;

      vs.loading({
        container: `#loading-stock-save`,
        type,
        scale: 0.5,
      });
      var selectedRows = this.gridApiMatchS.getSelectedRows(); 
      let parsedStock = selectedRows;
      selectedRows.forEach((val, index) => {
        parsedStock[index].MasterBarcode = this.stockno;
        parsedStock[index].Multiplier = this.selectedFactor;
      }); 
      this.$store
        .dispatch("stock/addStockList", parsedStock)
        .then((response) => {
          if (response.status == 200) {
            try {
              setTimeout(() => {
                vs.loading.close("#loading-stock-save > .con-vs-loading");
              }, 1000);
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              //  this.listStock();
              this.stockno = "";
              this.selectedFactor = "";
            } catch (error) {
              setTimeout(() => {
                vs.loading.close("#loading-stock-save > .con-vs-loading");
              }, 1000);
              console.log(error);
            }
          } else {
            vs.notify({
              text: response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            setTimeout(() => {
              vs.loading.close("#loading-stock-save > .con-vs-loading");
            }, 1000);
          }
        })
        .catch((error) => {
          vs.notify({
            text: error.toString(),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    errorImage(e) {
      if (e.type == "error")
        e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
    },
    mpControl(e) {
      if (
        !e.includes("Toplu") &&
        !e.includes("Flip") &&
        !e.includes("Php") &&
        !e.includes("Tümü")
      )
        return true;
      else return false;
    },
    onGridReadyProcess(params) {
      this.gridApiProcess = params.api;
      this.gridColumnApiProcess = params.columnApi;
    },
    onGridReadyMatchS(params) {
      this.gridApiMatchS = params.api;
      this.gridColumnApiMatchS = params.columnApi;
    },
		onGridReadyStock(params) {
      this.gridApiStock = params.api;
      this.gridColumnApiStock = params.columnApi;
    },
    getCustomerDepoList() {
      const vs = this.$vs;
      this.storehouse_choices = [];
      if (userJson.type == "fullfilment")
        this.$store
          .dispatch("storehouse/listStorehouseAllValues2", this.customer.CompanyId)
          .then((response) => {
            if (response.success == true) {
              this.storehouseForCustomerList = JSON.parse(response.json);
              this.storehouseForCustomerList.forEach((val, index) => {
                this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
              });
            } else console.log(response.statusText);
          });
      else
       { 
				let depotMethods = "listStorehouseForCompany"

				if (userJson.type == "dropshipping") depotMethods = "listStorehouseAllValues2Ds"
				this.$store
          .dispatch("storehouse/"+depotMethods, this.customer.CompanyId)
          .then((response) => {
            if (response.success == true) {
              this.storehouseForCustomerList = JSON.parse(response.json);
              this.storehouseForCustomerList.forEach((val, index) => {
                this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
              });
            } else console.log(response.statusText);
          });}
    },
    getCustomerMarketplaces() {
      const vs = this.$vs;
      this.timelineData = [];
      this.$store
        .dispatch("customer/listCustomerinfoForRole", this.customer.CompanyId)
        .then((response) => {
          if (response.success == true) {
            this.marketplace_choices = JSON.parse(response.json);
          } else console.log(response.statusText);
        });
    },
    getStockList(stock) {
      const vs = this.$vs;
      this.stockList = [];
      this.stockColumns = [];
      this.stockList = stock;
      this.stockListFiltered = stock;

      if (this.stockList.length > 0) {
        setTimeout(() => {
          vs.loading.close("#loading-stock-list > .con-vs-loading");
        }, 1000);
        let columnList = Object.keys(this.stockList[0]);
        this.stockColumns.push({
          headerCheckboxSelection: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,

          width: 20,
          pinned: "left",
        });

        columnList.forEach((val, index) => {
          if (
            val == "DepotName" ||
            val == "Stockno" ||
            val == "CustomerStockNo" ||
            val == "CompanyName" ||
            val == "StockName" ||
            val == "CompanyInfoName"
          ) {
            this.stockColumns.push({
              width: 150,
              headerName: this.$t(val),
              pinned: "left",
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          } else if (val == "Status")
            this.stockColumns.push({
              width: 80,
              headerName: this.$t(val),
              cellRendererFramework: "statusShowCellRenderer",
              field: val,
              filter: "agSetColumnFilter",
            });
          else if (
            val != "ActSupplierId" &&
            val != "DepotId" &&
            val != "CompanyInfoId" &&
            val != "CompanyId" &&
            val != "StockId" &&
            val != "UnitId" &&
            val.toString().includes("Date") == false
          )
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          else if (val.toString().includes("Date") == true) {
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    listStock() {
      var vs = this.$vs;
      if (this.marketplace == "" || this.customer == "" || this.storehouse == "") {
        vs.notify({
          text: this.$t("Validate"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        let type = "material";
        vs.loading({
          container: `#loading-stock-list`,
          type,
          scale: 0.5,
        });
        let obj = {
          companyInfoId: this.marketplace.CompanyInfoId,
          depotId: this.storehouse.value,
        };
        this.$store
          .dispatch("stock/pullStock", obj)
          .then((response) => {
            if (response.success == true) {
              let parsedStock = JSON.parse(response.json);
              parsedStock.forEach((val, index) => {
                parsedStock[index].DepotName = this.storehouse.name;
              });
              this.getStockList(parsedStock);
            } else {
              setTimeout(() => {
                vs.loading.close("#loading-stock-list> .con-vs-loading");
              }, 1000);
              vs.notify({
                text: response.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              vs.loading.close("#loading-stock-list> .con-vs-loading");
            }, 1000);
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    getMainStock() {
      this.mainBarcodes = this.stock;
      this.mainBarcodes.forEach((val, index) => {
        this.mainstock_options.push({
          value: val.StockId,
          name: val.StockName,
          code: val.Stockno,
          label: val.Stockno + "-" + val.StockName,
        });
      });
    },
    getSelectedStockWithBarcodeMatch() {},
  },
  mounted() {
    this.getMainStock();
    if (this.ROLE == "Company") {
      this.getCustomerMarketplaces();
      this.getCustomerDepoList();
      this.customer = { value: this.$store.state.AppActiveUser.companyid };
    }
    this.$root.$on("excelData", (paramDetail) => { 
      if (paramDetail) this.isUploadedAddExcel = true; 
      this.wholeAcceptedProductListAddExcel = paramDetail;
      this.setItem();
    });
    this.$root.$on("editMatchedBarcode", (paramDetail) => {
      this.editMatchedBarcode(paramDetail);
    });
    this.$root.$on("deleteMatchedBarcode", (paramDetail) => {
      this.deleteMatchedData = paramDetail;
      this.deleteMatchedBarcode();
    });
  },
  beforeDestroy() {
    this.$root.$off("excelData");
    this.$root.$off("editMatchedBarcode");
    this.$root.$off("deleteMatchedBarcode");
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    mpNameList: {
      get() {
        return this.$store.state.order.MpNameList;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    stock: {
      get() {
        return this.$store.state.stock.Stock;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  watch: {
    mpNameList(val) {
      this.getMpNameOptions();
      return val;
    },
    company(val) {
      this.customer_choices = val;
      return val;
    },
    stock(val) {
      if (val.length > 0) {
        this.getMainStock();
      }
      return val;
    },
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 130px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
[dir] .btn-group button {
  padding: 4px !important;
}
.con-vs-dialog {
  z-index: 520055;
}
</style>
